import { Validator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/Validator';
import { ValidationError } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/ValidatorError';
export class ManageListActionSettingsValidator extends Validator {
    validate(model) {
        if (!model.action) {
            throw new ValidationError('The manage list action is required');
        }
        if (!model.listName || model.listName == '') {
            throw new ValidationError('The manage list name is required');
        }
    }
}
